"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var constants_1 = require("./constants");
var helpers_1 = require("./helpers");
require("./widget.css");
var WidgetInput = function (_a) {
    var id = _a.id, _b = _a.country, country = _b === void 0 ? constants_1.Country.AU : _b, container = _a.container, onSelected = _a.onSelected, inputClassName = _a.inputClassName, _c = _a.listClassName, listClassName = _c === void 0 ? 'address-autocomplete__suggestions' : _c, _d = _a.itemClassName, itemClassName = _d === void 0 ? 'address-autocomplete__suggestions__item' : _d, _e = _a.hoverClassName, hoverClassName = _e === void 0 ? 'address-autocomplete__suggestions__item--active' : _e, addressFinderKey = _a.addressFinderKey, _f = _a.raw, raw = _f === void 0 ? false : _f, _g = _a.addressParams, addressParams = _g === void 0 ? {} : _g, props = (0, tslib_1.__rest)(_a, ["id", "country", "container", "onSelected", "inputClassName", "listClassName", "itemClassName", "hoverClassName", "addressFinderKey", "raw", "addressParams"]);
    var _h = (0, react_1.useState)(false), scriptLoaded = _h[0], setScriptLoaded = _h[1];
    var mounted = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        mounted.current = true;
        if (window.AddressFinder) {
            setScriptLoaded(true);
            return;
        }
        var script = document.createElement('script');
        script.src = constants_1.AddressFinderWidgetSrc;
        script.async = true;
        script.addEventListener('load', function () {
            if (mounted.current) {
                setScriptLoaded(true);
            }
        });
        window.document.body.appendChild(script);
        return function () {
            mounted.current = false;
            window.document.body.removeChild(script);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (scriptLoaded && mounted.current) {
            var widget = new window.AddressFinder.Widget(document.getElementById(id), addressFinderKey, country, {
                list_class: listClassName,
                item_class: itemClassName,
                hover_class: hoverClassName,
                manual_style: true,
                container: container || document.getElementById("".concat(constants_1.ContainerPrefix, "-").concat(id)),
                address_params: addressParams,
                max_results: 5,
            });
            widget.on('address:select', function (fullAddress, metaData) {
                var addressData = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, metaData), { country: country });
                if (!raw) {
                    addressData = (0, helpers_1.addressMetaToAddress)(metaData, country);
                }
                onSelected(fullAddress, addressData);
            });
        }
    }, [id, country, scriptLoaded]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("input", (0, tslib_1.__assign)({ "aria-autocomplete": "list", "aria-haspopup": true, "aria-owns": container ? container.id : "".concat(constants_1.ContainerPrefix, "-").concat(id), type: "text", autoComplete: "off", className: inputClassName, id: id }, props)),
        !container && react_1.default.createElement("div", { id: "".concat(constants_1.ContainerPrefix, "-").concat(id), className: "address-autocomplete" })));
};
exports.default = WidgetInput;
//# sourceMappingURL=WidgetInput.js.map